import type { BrandKit } from '../brand.types'
import { primary, secondary } from '@/styles/palette'
import logo from '@/assets/images/logo.png'
import favicon from '@/assets/icons/logo-fevicon.png'
import { ENV } from '@/config'

/**
 * Default kit — the AquaVitae / Lowcountry Male dual lockup and the teal
 * palette the platform has always shipped. Any host that is not mapped to a
 * specific organization falls back to this, so unmapped deployments look
 * exactly as they did before branding was introduced.
 */
export const swaashBrand: BrandKit = {
  id: 'swaash',
  name: ENV.APP_NAME,

  logo,
  logoOnBrand: logo,
  favicon,

  palette: {
    primary: {
      main: primary.main,
      dark: primary.dark,
      light: primary.light,
      lighter: primary[30],
      contrastText: primary.contrastText,
    },
    secondary: {
      main: secondary.main,
      dark: secondary.dark,
      light: secondary.light,
      lighter: secondary[30],
      contrastText: secondary.contrastText,
    },
  },

  brandSurface: `linear-gradient(135deg, ${primary.dark} 0%, ${primary.main} 100%)`,
}
